<template>
    <div>
      <div class="container-form px-3 py-3" v-if="(evaluator == 'council' || evaluator == 'rectory') && admissions_current_score && settings.show_admission_score">
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular">Promedio Admisiones: {{ admissions_current_score.average }}</h2>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex xs12 lg3 px-1>
                <h3>Areas a evaluar</h3>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Estandar</h3>
              </v-flex>
              <v-flex xs12 lg1 px-1>
                <h3>Calificación</h3>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Notas</h3>
              </v-flex>
            </v-layout>
            <v-layout v-for="(item, index) in admissions_score_items" row wrap mt-2 align-center :key="index">
              <v-flex xs12 lg3 px-1>
                {{ item.area }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                {{ item.standard }}
              </v-flex>
              <v-flex xs12 lg1 px-1 text-xs-center>
                {{ admissions_current_score.score[item.id]['score'] }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                {{ admissions_current_score.score[item.id]['notes'] }}
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <h2 class="font-weight-regular">Promedio Admisiones: {{ admissions_current_score.average }}</h2>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="container-form px-3 py-3" v-if="(evaluator == 'admissions' || evaluator == 'rectory') && counsel_current_score && settings.show_counsel_score">
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular">Promedio Consejería: {{ counsel_current_score.average }}</h2>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex xs12 lg3 px-1>
                <h3>Areas a evaluar</h3>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Estandar</h3>
              </v-flex>
              <v-flex xs12 lg1 px-1>
                <h3>Calificación</h3>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Notas</h3>
              </v-flex>
            </v-layout>
            <v-layout v-for="(item, index) in counsel_score_items" row wrap mt-2 align-center :key="index">
              <v-flex xs12 lg3 px-1>
                {{ item.area }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                {{ item.standard }}
              </v-flex>
              <v-flex xs12 lg1 px-1 text-xs-center>
                {{ counsel_current_score.score[item.id]['score'] }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                {{ counsel_current_score.score[item.id]['notes'] }}
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <h2 class="font-weight-regular">Promedio Consejería: {{ counsel_current_score.average }}</h2>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="container-form px-3 py-3" v-if="(evaluator == 'admissions' || evaluator == 'council') && rectory_current_score && settings.show_rectory_score">
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular">Promedio Rectoría/Comité: {{ rectory_current_score.average }}</h2>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex xs12 lg3 px-1>
                <h3>Areas a evaluar</h3>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Estandar</h3>
              </v-flex>
              <v-flex xs12 lg1 px-1>
                <h3>Calificación</h3>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Notas</h3>
              </v-flex>
            </v-layout>
            <v-layout v-for="(item, index) in rectory_score_items" row wrap mt-2 align-center :key="index">
              <v-flex xs12 lg3 px-1>
                {{ item.area }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                {{ item.standard }}
              </v-flex>
              <v-flex xs12 lg1 px-1 text-xs-center>
                {{ rectory_current_score.score[item.id]['score'] }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                {{ rectory_current_score.score[item.id]['notes'] }}
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <h2 class="font-weight-regular">Promedio Rectoría/Comité: {{ rectory_current_score.average }}</h2>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="container-form px-3 py-3">
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular" v-if="evaluator == 'admissions'">Promedio Admisiones: {{ current_score.average }}</h2>
            <h2 class="font-weight-regular" v-else-if="evaluator == 'council'">Promedio Consejería: {{ current_score.average }}</h2>
            <h2 class="font-weight-regular" v-else-if="evaluator == 'rectory'">Promedio Rectoría/Comité: {{ current_score.average }}</h2>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex xs12 lg3 px-1>
                <h3>Areas a evaluar</h3>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Estandar</h3>
              </v-flex>
              <v-flex xs12 lg1 px-1>
                <h3>Calificación</h3>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Notas</h3>
              </v-flex>
            </v-layout>
            <v-layout v-for="(item, index) in score_items" row wrap mt-2 align-center :key="index">
              <v-flex xs12 lg3 px-1>
                {{ item.area }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                {{ item.standard }}
              </v-flex>
              <v-flex xs12 lg1 px-1>
                  <v-select
                    v-model="current_score.score[item.id]['score']"
                    :items="range(item.range[0], item.range[1])"
                    @change="average()"
                  ></v-select>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <v-textarea
                  rows="1"
                  row-height="15"
                  outline
                  solo
                  name="notes"
                  v-model="current_score.score[item.id]['notes']"
                >
                </v-textarea>
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
            <h2 class="font-weight-regular" v-if="evaluator == 'admissions'">Promedio Admisiones: {{ current_score.average }}</h2>
            <h2 class="font-weight-regular" v-else-if="evaluator == 'council'">Promedio Consejería: {{ current_score.average }}</h2>
            <h2 class="font-weight-regular" v-else-if="evaluator == 'rectory'">Promedio Rectoría/Comité: {{ current_score.average }}</h2>
            </div>
            <v-select
              label="Continua en el proceso?"
              v-model="current_score.continua"
              :items="yesno_options"
            ></v-select>
            <v-textarea
              label="Notas generales de la familia"
              rows="2"
              name="notes"
              v-model="current_score.notes"
            >
            </v-textarea>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue" @click="saveScore">{{$t('admissions.entries.form.save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'admissions-score',
  props: {
    score: {
      type: Object,
      required: true
    },
    evaluator: {
      type: String,
    },
    settings: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      current_score: this.$props.score.score,
      score_items: this.$props.score.items,
      admissions_current_score: this.$props.score.admissions_score,
      admissions_score_items: this.$props.score.admissions_items,
      counsel_current_score: this.$props.score.counsel_score,
      counsel_score_items: this.$props.score.counsel_items,
      rectory_current_score: this.$props.score.rectory_score,
      rectory_score_items: this.$props.score.rectory_items,
      yesno_options: [
        {value: 0, text: "No"},
        {value: 1, text: "Si"},
      ],
    }
  },
  watch: {
    score(newVal, oldVal) {
      this.current_score = newVal.score
      this.score_items = newVal.items
      this.admissions_current_score = newVal.admissions_score
      this.admissions_score_items = newVal.admissions_items
      this.counsel_current_score = newVal.counsel_score
      this.counsel_score_items = newVal.counsel_items
      this.rectory_current_score = newVal.rectory_score
      this.rectory_score_items = newVal.rectory_items
    },
  },
  methods: {
    range(min,max) {
      let array = []
      let j = 0;
      for(let i = min; i <= max; i++){
        array[j] = i;
        j++;
      }
      return array;
    },
    average() {
      let average = 0
      const score = this.current_score.score

      this.score_items.forEach((item) => {
        average += score[item.id].score * item.weight
      });

      this.current_score.average = average
    },
    async saveScore() {
      const payload = {
        score_id : this.current_score.id,
        score : this.current_score.score,
        average : this.current_score.average,
        notes : this.current_score.notes,
        continua : this.current_score.continua
      }
      await axios.put('/api/admissions/family_score', payload)
        .then(resp => {
          if (resp.status === 200) {
            this.$emit('fetchEntries')
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'Calificación guardada con éxito.',
              modal: false
            })
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .container-form{
    background: #6198c8;
  }
  .container-form-inner{
    background: #F2F2F2;
    border-radius: 30px;
  }
  .container-form-inner .v-card__title, .v-expansion-panel__header .v-card__title{
    color: #004990;
    justify-content: center;
    background: #FFF;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/score.vue